module.exports = __webpack_public_path__ + "fonts/Inter-800-greek74.4a4b49c.woff2";